<template>
  <UPageSection title="Doneren">
    <DonateContent class="grid gap-4 md:grid-cols-2" />
  </UPageSection>
</template>
